import MemoizedShareTable from "./MemoizedShareTable";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import * as config from "config";
import * as _ from "lodash";
import { memo, useState } from "react";
import { connect } from "react-redux";
import * as towerPricingActions from "store/actions/pricing/tower/towerPricingActions";

/**
 * Row styling for a layer we are on: the brand accent row background used for
 * highlighted layers elsewhere (the summary tower diagram, the layers summary),
 * with a bar of the full accent down the left edge.
 */
const ownLayerRowSx = (theme) => ({
  backgroundColor: theme.brand.accent[200],
  "& > td:first-of-type": {
    boxShadow: `inset 4px 0 0 ${theme.brand.accent[500]}`,
  },
});

const TowerTableRow = ({
  columns,
  layer,
  layerIndex,
  isNewRow,
  isSelectedRow,
  isOwnLayer = false,
  priorLayers,
  dispatch,
  updateLimit,
  updateAttachment,
  updateMarketGrossWrittenPremium,
  updateSelected,
  addLayer,
  deleteLayer,
  updateLayer,
  updateShare,
  deleteShare,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <>
      <TableRow
        style={
          isSelectedRow
            ? { background: config.SELECTED_ROW_BACKGROUND_COLOR }
            : {}
        }
        sx={isOwnLayer ? ownLayerRowSx : undefined}
        data-own-layer={isOwnLayer ? "true" : undefined}
      >
        {columns.map(({ key, Cell }) => (
          <Cell
            key={key}
            {...{
              layer,
              layerIndex,
              isNewRow,
              isSelectedRow,
              isExpanded,
              priorLayers,
              dispatch: {
                updateLimit,
                updateAttachment,
                updateMarketGrossWrittenPremium,
                updateSelected,
                addLayer,
                deleteLayer,
                updateLayer,
                updateShare,
                deleteShare,
                setIsExpanded,
                ...dispatch,
              },
            }}
          />
        ))}
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={1000}>
          <Collapse in={isExpanded} timeout={"auto"} unmountOnExit>
            <Box sx={{ margin: 1, marginLeft: 10 }}>
              <MemoizedShareTable
                layer={layer}
                layerIndex={layerIndex}
                updateShare={updateShare}
                deleteShare={deleteShare}
              />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

const mapDispatchToProps = {
  updateLimit: towerPricingActions.updateLimit,
  updateAttachment: towerPricingActions.updateAttachment,
  updateMarketGrossWrittenPremium:
    towerPricingActions.updateMarketGrossWrittenPremium,
  updateSelected: towerPricingActions.updateSelected,
  addLayer: towerPricingActions.addLayer,
  updateLayer: towerPricingActions.updateLayer,
  deleteLayer: towerPricingActions.deleteLayer,
  updateShare: towerPricingActions.updateShare,
  deleteShare: towerPricingActions.deleteShare,
};

export default memo(
  connect(null, mapDispatchToProps)(TowerTableRow),
  _.isEqual
);
